export interface LoginRequest {
  email: string;
  password: string;
}

export interface WorkshopInfo {
  workshopId: string;
  name: string;
}

export interface LoginResponse {
  token: string;
  email: string;
  role: string;
  userId: string;
  firstName: string;
  lastName: string;
  workshops?: WorkshopInfo[]; // Array of workshops user belongs to
  isFirstLogin?: boolean;
  user?: User; // Opsiyonel, eski format desteği için
}

export enum OrderStatus {
  Atanmadi = 1, // Atanmadı
  Islemde = 2, // İşlemde
  IptalEdildi = 3, // İptal Edildi
  Tamamlandi = 4, // Tamamlandı
}

export enum OrderUnit {
  Adet = 1, // Database ID: 1
  Metre = 2, // Database ID: 2
  Takim = 3, // Database ID: 3 (Takım birimi)
  Pano = 7, // Database ID: 7 (Pano birimi)
}

// Maliyet hesaplama tipleri
export enum CalculationType {
  Simple = 0, // Basit hesaplama - Quantity × UnitPrice
  TwoDimensional = 1, // İki boyutlu - Quantity × Quantity2 × UnitPrice
  PieceFitting = 2, // Varak/Sticker - (MaterialWidth/En) × (MaterialHeight/Boy) = adet/metre
  MeterBased = 3, // Metre bazlı hesaplama
  AreaBased = 4, // Alan bazlı (m²) hesaplama
  PaintBased = 5, // Boya hesaplama - Litre × Kat Sayısı (Çeşit Sayısı yalnız bilgi amaçlı)
  CustomCost = 6, // Özel Maliyet - TotalCost direkt girilir (Fason üretim, sabit maliyetler)
}

export interface ExchangeRate {
  exchangeRateId: string;
  currencyCode: string;
  currencyName: string;
  forexBuying: number;
  forexSelling: number;
  banknoteBuying: number;
  banknoteSelling: number;
  rateDate: string;
  unit: number;
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
  isActive: boolean;
}

export interface Currency {
  code: string;
  name: string;
}

export interface InvoiceType {
  invoiceTypeId: number; // Backend'de int olarak tanımlı (1, 2, 3)
  name: string;
  description?: string;
}

// Firma Tipi Enum
export enum FirmType {
  TuzelKisi = 0, // Tüzel Kişi (Şirket)
  GercekKisi = 1, // Gerçek Kişi (Şahıs)
}

export interface City {
  cityId: number;
  cityName: string; // Backend'de CityName olarak geliyor
  name?: string; // Compatibility için
  code?: string;
}

export interface District {
  districtId: number;
  districtName: string; // Backend'de DistrictName olarak geliyor
  name?: string; // Compatibility için
  cityId: number;
  city?: City;
}

export interface TaxOffice {
  taxOfficeId: number;
  name: string;
  cityId: number;
  city?: City;
}

export interface Firm {
  firmId: string;
  firmCode: string;
  firmName: string;
  firmType?: FirmType;
  description?: string;
  address?: string;

  // İlişkisel alanlar
  cityId?: number;
  city?: City;
  districtId?: number;
  district?: District;
  taxOfficeId?: number;
  taxOffice?: TaxOffice;

  countryCode?: string;
  countryName?: string;
  contactPerson?: string;
  phone?: string;
  email?: string;
  notificationEmail?: string;
  taxNumber?: string;
  tckn?: string;
  firstName?: string;
  lastName?: string;
  invoiceTypeId?: number; // Backend'de int? nullable olarak tanımlı
  invoiceType?: InvoiceType;
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
  isActive: boolean;
}
export interface User {
  userId: string;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  workshops?: WorkshopInfo[]; // Array of workshops user belongs to
  isActive: boolean;
  isFirstLogin?: boolean; // geçici şifreyle henüz giriş yapmadı
}

export interface Model {
  modelId: string;
  modelCode: string;
  modelName: string;
  firmId?: string; // Firma ID'si
  patternCode?: string; // Desen kodu
  description?: string;
  category?: string;
  season?: string;
  color?: string;
  size?: string;
  fabric?: string;
  estimatedPrice?: number;
  price?: number;
  priceCurrency?: string;
  estimatedProductionTime?: number;
  imageUrl?: string;
  productionStockId?: string; // Üretim stoğu (Mamül) — sipariş tamamlanınca BOM tüketimi için
}

export interface ModelPriceHistoryItem {
  orderId: string;
  acceptanceDate: string;
  price: number;
  priceCurrency: string;
  quantity: number;
  orderUnitName: string;
  firmName: string;
  firmId: string;
}

export interface ModelPriceHistory {
  modelId: string;
  modelCode: string;
  modelName: string;
  currentPrice?: number;
  currentPriceCurrency?: string;
  priceHistory: ModelPriceHistoryItem[];
}

// Model kataloğu özeti (GET /api/Model/overview) — görseller, sipariş ve son maliyet seti
export interface ModelOverview {
  modelId: string;
  modelCode: string;
  modelName: string;
  firmId?: string | null;
  firmName?: string | null;
  firmCode?: string | null;
  patternCode?: string | null;
  description?: string | null;
  category?: string | null;
  season?: string | null;
  color?: string | null;
  size?: string | null;
  price?: number | null;
  priceCurrency?: string | null;
  estimatedPrice?: number | null;
  estimatedProductionTime?: number | null;
  imageUrl?: string | null;
  productionStockId?: string | null;
  productionStockName?: string | null;
  createdAt: string;
  imageUrls: string[];
  orderCount: number;
  activeOrderCount: number;
  lastOrderDate?: string | null;
  lastOrderPrice?: number | null;
  lastOrderCurrency?: string | null;
  costOrderCount: number;
  lastCostOrderId?: string | null;
  lastCostDate?: string | null;
  lastCostQuantity?: number | null;
  lastCostItemCount: number;
  lastCostTotalTry?: number | null;
  lastCostUnitTry?: number | null;
  lastCostFinalTry?: number | null;
  lastCostFinalUnitTry?: number | null;
  lastCostHasUnknownRate: boolean;
}

export interface ModelOverviewResponse {
  overheadRate: number;
  profitMargin: number;
  models: ModelOverview[];
}

export interface Workshop {
  workshopId: string;
  name: string;
  description?: string;
  location?: string;
  contactPerson?: string;
  phone?: string;
  displayOrder?: number;
}

export interface Operator {
  operatorId: string;
  firstName: string;
  lastName: string;
  phone?: string;
  email?: string;
  specialization?: string;
  workshopId?: string;
  workshop?: Workshop;
}

export interface Technic {
  technicId: string;
  name: string;
  description?: string;
  category?: string;
  workshopId?: string;
  workshop?: Workshop;
}

export interface OrderImage {
  orderImageId: string;
  orderId: string;
  imageUrl: string;
  description?: string;
  displayOrder: number;
}

export interface OrderTechnic {
  orderTechnicId?: string;
  orderId: string;
  technicId: string;
  technic?: Technic;
}

export interface Order {
  orderId: string;
  acceptanceDate: string; // Backend: AcceptanceDate
  modelistUserId?: string; // Modelist assignment for digital/sticket orders
  modelistUser?: User; // Navigation property for modelist user
  completionDate?: string; // Backend: CompletionDate (nullable)
  firmId: string; // Backend: FirmId
  firm?: Firm; // Navigation property
  modelId: string; // Backend: ModelId
  model?: Model;
  quantity: number; // Backend: Quantity
  unit?: OrderUnit; // Backend: Unit (enum: Adet=0, Metre=1, Takim=2)
  pieceCount?: number; // Backend: PieceCount (Takım seçiliyse takımda kaç parça var)
  width?: number; // Backend: Width (En) - opsiyonel
  height?: number; // Backend: Height (Boy) - opsiyonel
  price?: number; // Backend: Price (nullable decimal, 4 ondalık)
  vatRate?: number; // Backend: VatRate (nullable decimal 5,2) — fatura kesilirken düzenlenebilir
  priceCurrency?: string; // Backend: PriceCurrency (döviz kodu: USD, EUR, TRY, vb.)
  currency?: string; // Eski alan - geriye dönük uyumluluk için
  workshopId?: string; // Backend: WorkshopId (nullable)
  workshop?: Workshop;
  workshopDuration?: string; // Kanban endpoint'inden gelen atölyede geçen süre
  operatorId?: string; // Backend: OperatorId (nullable)
  operator?: Operator;
  priority?: string; // Backend: Priority (nullable, max 50)
  deadline?: string; // Backend: Deadline (nullable DateTime)
  note?: string; // Backend: Note (nullable, max 500)
  invoice?: string; // Backend: Invoice (nullable, max 100)
  invoiceNumber?: string; // Backend: InvoiceNumber (nullable, max 50)
  invoiceTypeId?: number; // Firmanın fatura tipi (1=E-Fatura, 2=E-Arşiv, 3=Faturasız)
  invoiceTypeName?: string;
  status?: OrderStatus; // Backend: Status (enum)
  isSample?: boolean; // Backend: IsSample - Numune sipariş mi?
  qrCodeUrl?: string; // Backend: QrCodeUrl (nullable)
  qrCode?: string; // Eski alan - geriye dönük uyumluluk için
  images?: OrderImage[];
  orderTechnics?: OrderTechnic[];
  // AuditableEntity fields
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
  isActive: boolean;
}

// Cost Management Types
export interface CostCategory {
  costCategoryId: string;
  category: string; // Backend expects 'category' field
  categoryName: string; // Keep for frontend compatibility
  description?: string;
  displayOrder?: number;
  isActive: boolean;
}

export interface CostSubCategory {
  costSubCategoryId: string; // GUID
  costCategoryId: string; // GUID
  subCategory: string; // Backend expects 'subCategory'
  subCategoryName: string;
  description?: string;
  displayOrder: number;
  isActive: boolean;
  costCategory?: CostCategory;
}

/** Maliyet kalemi ↔ stok bağı. Miktar, kalemin BİR birimi içindir. */
export interface CostItemStockLink {
  stockId: string;
  stockName?: string | null;
  stockUnit?: string | null;
  currentStock?: number;
  quantity: number;
  wastagePercentage: number;
  sortOrder?: number;
  description?: string | null;
}

export interface CostItem {
  costItemId: string; // GUID
  costCategoryId: string; // GUID
  costUnitId?: string; // GUID - Yeni format
  costUnitId2?: string; // GUID - İkinci birim (opsiyonel)
  costUnitId3?: string; // GUID - Üçüncü birim (opsiyonel, sadece referans)
  itemName: string;
  description?: string;
  unit?: string; // String format (unitCode) - Opsiyonel, hesaplama tipine göre belirlenir
  unitName?: string; // Birim adı (Metre, Kilogram, Litre vb.) - Backend'den geliyor
  unit2?: string; // İkinci birim adı (opsiyonel, çoklu boyut için) - DEPRECATED: costUnit2.unitName kullan
  unitPrice: number;
  currency: string;
  supplier?: string;
  wastagePercentage?: number; // Fire yüzdesi (0-100)
  minimumOrderQuantity?: number;
  discountPercentage?: number;
  lastPriceUpdate: string;
  isActive: boolean;
  // Hesaplama tipi ve ilgili alanlar
  calculationType?: CalculationType; // Hesaplama tipi (Simple, PieceFitting vb.)
  materialWidth?: number; // Malzeme eni (Varak: 150, Sticker: 59)
  materialHeight?: number; // Malzeme boyu per metre (100)
  quantity1Label?: string; // 1. miktar başlığı ("En", "Miktar", "Kişi")
  quantity2Label?: string; // 2. miktar başlığı ("Boy", "Süre", "Saat")
  quantity3Label?: string; // 3. miktar başlığı ("Sipariş Adedi", "Adet")
  /** Bu kalemin tükettiği stoklar (0..N). Maliyet girildiği anda düşer, silinince geri konur. */
  stocks?: CostItemStockLink[];
  // Navigation properties
  costCategory?: CostCategory;
}

export interface ModelCost {
  modelCostId: string;
  modelId: string;
  modelName?: string; // Backend'den flat DTO
  modelCode?: string; // Backend'den flat DTO
  orderId?: string; // Sipariş ID'si (opsiyonel - genel model maliyetleri için null olabilir)
  orderAcceptanceDate?: string; // Backend'den flat DTO
  orderQuantity?: number; // Sipariş adedi (Backend'den flat DTO)
  firmId?: string; // Firma ID'si (flat DTO)
  firmName?: string; // Firma adı (flat DTO)
  oldWorkshopId?: string; // Atölye ID'si (flat DTO)
  oldWorkshopName?: string; // Atölye adı (flat DTO)
  costItemId: string;
  costItemName?: string; // Backend'den flat DTO
  costCategoryName?: string; // Backend'den flat DTO
  quantity: number;
  unit?: string;
  quantity2?: number; // İkinci miktar (boy, kişi sayısı, süre vb.)
  unit2?: string; // İkinci birim adı
  quantity3?: number; // Üçüncü miktar (opsiyonel, referans)
  unit3?: string; // Üçüncü birim adı (opsiyonel, referans)
  quantity1Label?: string; // 1. miktar başlığı ("En", "Miktar", "Kişi", vb.)
  quantity2Label?: string; // 2. miktar başlığı ("Boy", "Çeşit Sayısı", vb.)
  costUnitId2?: string; // İkinci birim referansı
  costUnitId3?: string; // Üçüncü birim referansı (opsiyonel, referans)
  calculationType?: CalculationType; // Hesaplama tipi (Simple, PieceFitting, CustomCost vb.)
  unitPrice?: number;
  totalCost?: number;
  currency?: string;
  actualQuantityNeeded?: number;
  wastagePercentage?: number; // Fire yüzdesi (0-100)
  usage?: string;
  notes?: string; // Backend'den flat DTO
  priority?: number;
  isActive: boolean;
  usdRate?: number; // USD kuru (maliyet kaydedildiği andaki kur)
  eurRate?: number; // EUR kuru (maliyet kaydedildiği andaki kur)
  gbpRate?: number; // GBP kuru (maliyet kaydedildiği andaki kur)
  exchangeRateDate?: string; // Kur tarihi
  createdAt?: string; // Kayıt oluşturulma tarihi
  // Settings-based pricing calculations
  overheadCostRate?: number; // Genel gider oranı (%)
  profitMargin?: number; // Kar marjı (%)
  costWithOverhead?: number; // Genel gider eklenmiş maliyet
  finalCostWithProfit?: number; // Kar marjı eklenmiş nihai maliyet
  // PaintBased calculation type için özel alanlar
  layerCount?: number; // Kat sayısı (PaintBased için)
  applicationMethod?: string; // Uygulama yöntemi (PaintBased için)
  // AreaBased calculation type için özel alan
  coverageArea?: number; // Kaplama alanı (AreaBased için)
  model?: Model; // Geriye dönük uyumluluk için
  order?: Order; // Geriye dönük uyumluluk için
  costItem?: CostItem; // Geriye dönük uyumluluk için
}

export interface ModelCostSummary {
  modelId: string;
  modelName: string;
  totalItems: number;
  totalCost: number;
  currency: string;
  costsByCategory: {
    categoryName: string;
    itemCount: number;
    totalCost: number;
    items: {
      itemName: string;
      quantity: number;
      unit: string;
      unitPrice: number;
      totalCost: number;
      usage?: string;
    }[];
  }[];
}

export interface WorkshopCostItem {
  workshopCostItemId: string;
  workshopId: string;
  workshopName?: string;
  costItemId: string;
  costItemName?: string;
  costItemDescription?: string;
  categoryName?: string;
  costUnitId?: string;
  unitName?: string;
  unitCode?: string;
  costUnitId2?: string;
  unitName2?: string;
  unitCode2?: string;
  costUnitId3?: string;
  unitName3?: string;
  unitCode3?: string;
  // Hesaplama tipi ve özel miktar etiketleri (CostItem'dan gelen)
  calculationType?: CalculationType;
  materialWidth?: number; // Malzeme eni (Varak: 150, Sticker: 59)
  materialHeight?: number; // Malzeme boyu per metre (100)
  quantity1Label?: string;
  quantity2Label?: string;
  quantity3Label?: string;
  standardPrice?: number;
  standardCurrency?: string;
  workshopSpecificPrice?: number;
  workshopCurrency?: string;
  workshopDiscountPercentage?: number;
  effectivePrice: number;
  effectiveCurrency?: string;
  priority?: number;
  isPreferred: boolean;
  notes?: string;
  isActive: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
  workshop?: Workshop;
  costItem?: CostItem; // Geriye dönük uyumluluk için
}

export interface OrderWorkshopCost {
  orderWorkshopCostId: string;
  orderId: string;
  workshopId: string;
  costItemId: string;
  quantityUsed: number;
  quantity2?: number; // İkinci boyut (opsiyonel)
  quantity3?: number; // Üçüncü boyut (opsiyonel, referans)
  unit?: string; // Birim (required by backend ModelCost)
  unit2?: string; // İkinci birim (opsiyonel)
  unit3?: string; // Üçüncü birim (opsiyonel, referans)
  costUnitId3?: string; // Üçüncü birim ID (opsiyonel, referans)
  wastagePercentage?: number; // Fire yüzdesi (0-100)
  actualPrice: number;
  currency: string;
  totalCost: number;
  notes?: string;
  isActive: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
  order?: Order;
  workshop?: Workshop;
  costItem?: CostItem;
}

export interface Settings {
  settingsId: string;
  settingsName: string;
  profitMargin: number; // Kar marjı (%)
  overheadCostRate: number; // Genel gider oranı (%)
  pricesIncludeVat: boolean; // Sipariş fiyatları KDV dahil mi
  defaultVatRate: number; // Yeni siparişlerde önerilecek KDV oranı (%)
  vatRates: string; // Seçilebilir KDV oranları, virgülle ayrılmış (ör. "0,1,10,20")
  faturasizSeriesCode: string; // Faturasız belge numarası ön eki (ör. "PRF")
  invoiceLineSuffix?: string; // Belge satırında model kodunun sağına yazılan metin (ör. "Nolu Baskı")
  defaultPaymentTermDays: number; // Cari: fatura vadesi (gün)
  notifyCustomerByEmail: boolean; // Müşteriye sipariş/sevkiyat bildirimi gönderilsin mi
  publicBookingEnabled: boolean; // Girişsiz randevu sayfası yayında mı (varsayılan kapalı)
  isActive: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt?: string;
  updatedBy?: string;
}

// Pagination types
export interface PaginatedResult<T> {
  items: T[];
  pageNumber: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}

// ============================================
// STOK YÖNETİM SİSTEMİ TİPLERİ
// ============================================

// Stok Tipi Enum
export enum StockType {
  Hammadde = 1, // Ham madde - kumaş, iplik, boya vb.
  YariMamul = 2, // Yarı mamül - kesilmiş kumaş, boyanmış iplik vb.
  Mamul = 3, // Mamül - bitmiş ürün, dikim için hazır parça vb.
}

// Stok Hareket Tipi Enum
export enum StockMovementType {
  Giris = 1, // Giriş
  Cikis = 2, // Çıkış
  Transfer = 3, // Transfer
  Sayim = 4, // Sayım Düzeltmesi
  Iade = 5, // İade
  Fire = 6, // Fire/Zayi
}

// Stok Kategorisi
export interface StockCategory {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

// Stok
export interface Stock {
  id: string;
  productCode: string;
  productName: string;
  description?: string;
  categoryId: string;
  category?: StockCategory;
  stockType?: StockType;
  unit: string;
  currentStock: number;
  minimumStock?: number;
  maximumStock?: number;
  unitPrice?: number;
  currency?: string;
  warehouseLocation?: string;
  supplier?: string;
  supplierId?: string | null; // Satın Alma tedarikçi kartına bağ
  supplierName?: string | null; // bağlı tedarikçinin adı (yoksa serbest metin)
  color?: string;
  size?: string;
  barcode?: string;
  isActive: boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

// Stok Hareketi
export interface StockMovement {
  id: string;
  stockId: string;
  stock?: Stock;
  movementType: StockMovementType;
  quantity: number;
  unitPrice?: number;
  totalPrice?: number;
  currency?: string;
  referenceNo?: string;
  referenceType?: string;
  description?: string;
  movementDate: string;
  movedBy?: string;
  fromWarehouse?: string;
  toWarehouse?: string;
  relatedOrderId?: number;
  relatedOrder?: Order;
  /** Maliyet girişinden doğan hareketlerde malzemenin harcandığı atölye (sunucu türetir). */
  workshopName?: string;
  isActive: boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

// Stok Reçetesi (BOM - Bill of Materials)
export interface StockRecipe {
  id: string;
  parentStockId: string;
  parentStock?: Stock;
  childStockId: string;
  childStock?: Stock;
  requiredQuantity: number;
  wastagePercentage?: number;
  description?: string;
  sortOrder?: number;
  isActive: boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

// Stok Birimi
export interface StockUnit {
  id: string;
  unitName: string;
  abbreviation?: string;
  sortOrder?: number;
  isActive: boolean;
  createdAt?: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

// Üretim Tüketim İsteği
export interface ProductionConsumeRequest {
  stockId: string;
  quantity: number;
  referenceNo?: string;
  movedBy?: string;
  relatedOrderId?: string;
}

// Stok Oluşturma/Güncelleme İsteği
export interface StockRequest {
  id?: string;
  productCode: string;
  productName: string;
  description?: string;
  categoryId: string;
  stockType?: StockType;
  unit: string;
  currentStock: number;
  minimumStock?: number;
  maximumStock?: number;
  unitPrice?: number;
  currency?: string;
  warehouseLocation?: string;
  supplier?: string;
  supplierId?: string | null;
  color?: string;
  size?: string;
  barcode?: string;
  isActive?: boolean;
}

// Stok Hareketi Oluşturma/Güncelleme İsteği
export interface StockMovementRequest {
  id?: string;
  stockId: string;
  movementType: StockMovementType;
  quantity: number;
  unitPrice?: number;
  totalPrice?: number;
  currency?: string;
  referenceNo?: string;
  referenceType?: string;
  description?: string;
  movementDate?: string;
  movedBy?: string;
  fromWarehouse?: string;
  toWarehouse?: string;
  relatedOrderId?: number;
  isActive?: boolean;
}

// Stok Reçetesi Oluşturma/Güncelleme İsteği
export interface StockRecipeRequest {
  id?: string;
  parentStockId: string;
  childStockId: string;
  requiredQuantity: number;
  wastagePercentage?: number;
  description?: string;
  sortOrder?: number;
  isActive?: boolean;
}

// Tam BOM Ağacı (Rekürsif)
/**
 * GET /StockRecipe/FullBOM/{id} yanıtı — sunucunun GERÇEK şekli.
 * Eski `FullBOMItem` tipi `children` bekliyordu; sunucu `billOfMaterials`
 * döndürdüğü için ürün ağacı hiç çizilmiyordu.
 */
export interface FullBOMEntry {
  id: string; // reçete satırı kimliği (StockRecipe.id)
  childStockId: string;
  childStock: Stock;
  requiredQuantity: number;
  wastagePercentage?: number;
  totalQuantityWithWastage?: number;
  description?: string;
  sortOrder?: number;
  children?: FullBOMEntry[];
}
export interface FullBOMResponse {
  stock: Stock;
  billOfMaterials: FullBOMEntry[];
}

// Report types
export interface OrderCostItemDto {
  costItemName: string;
  quantity: number;
  unitPrice: number;
  totalCost: number;
  currency: string;
}

export interface OrderWithCostReportDto {
  orderId: string;
  orderCode: string;
  acceptanceDate: string;
  completionDate?: string;
  firmId: string;
  firmName: string;
  modelId: string;
  modelCode: string;
  modelName: string;
  quantity: number;
  unit: string;
  price?: number;
  priceCurrency: string;
  technics?: string[]; // Eski alan (backward compatibility)
  technicNames?: string[]; // Yeni alan
  paintCount?: number; // Boya adedi (PaintBased kalemlerin çeşit sayısı toplamı)
  costItems: OrderCostItemDto[];
  totalCostTRY: number;
  totalCostUSD: number;
  totalCostEUR: number;
  costWithOverhead: number;
  finalCostWithProfit: number;
}

export interface ReportSummaryDto {
  totalQuantity: number;
  totalAmount: number;
  totalCost: number;
  totalCostWithOverhead: number;
  totalFinalCost: number;
  profitLoss: number;
  profitLossPercentage: number;
}

// Aylık Adet Raporu
export interface MonthlyQuantityDto {
  year: number;
  month: number;
  monthName: string;
  orderCount: number;
  totalQuantity: number;
  totalPieceCount: number;
}

// Aylık Ciro Raporu
export interface MonthlyRevenueDto {
  year: number;
  month: number;
  monthName: string;
  orderCount: number;
  totalQuantity: number;
  revenueTRY: number;
  revenueUSD: number;
  revenueEUR: number;
  totalRevenueTRY: number;
}

// Müşteri Bazlı Ciro ve Adet Raporu
export interface CustomerRevenueDto {
  firmId: string;
  firmName: string;
  firmCode: string;
  orderCount: number;
  totalQuantity: number;
  totalPieceCount: number;
  revenueTRY: number;
  revenueUSD: number;
  revenueEUR: number;
  totalRevenueTRY: number;
}

// Aylık Kâr Raporu
export interface MonthlyProfitDto {
  year: number;
  month: number;
  monthName: string;
  orderCount: number;
  totalRevenueTRY: number;
  totalCostTRY: number;
  totalCostWithOverhead: number;
  grossProfit: number;
  netProfit: number;
  profitMarginPercent: number;
}

// Dynamic Report types
export interface DynamicReportColumn {
  fieldName: string;
  displayName: string;
  dataType: string;
  isFilterable: boolean;
  isSortable: boolean;
  isGroupable: boolean;
  isAggregatable: boolean;
  hasValueList?: boolean;
}

export interface ReportColumnMeta {
  label: string;
  dataType: string;
}

export interface DynamicReportDataSource {
  dataSourceName: string;
  displayName: string;
  description: string;
  availableColumns: DynamicReportColumn[];
}

export interface DynamicReportFilter {
  field: string;
  operator: string;
  value: string;
  value2?: string;
}

export interface DynamicReportAggregation {
  field: string;
  function: string;
  alias: string;
}

export interface DynamicReportRequest {
  dataSource: string;
  selectedColumns: string[];
  filters: DynamicReportFilter[];
  groupByColumns: string[] | null;
  aggregations: DynamicReportAggregation[] | null;
  sortBy?: string;
  sortDescending?: boolean;
  pageNumber: number;
  pageSize: number;
  targetCurrency?: string; // TRY | USD | EUR | GBP
  rateMode?: string; // historical | current
}

export interface DynamicReportResponse {
  columns: string[];
  columnMeta: Record<string, ReportColumnMeta>;
  rows: Record<string, any>[];
  aggregations: any;
  targetCurrency: string;
  rateMode: string;
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

// ===== Birleşik Pivot Rapor =====

export interface PivotFieldInfo {
  fieldName: string;
  displayName: string;
  dataType: string; // string | datetime | decimal | int | bool | currency
  category: string; // Tarih, Sipariş, Firma, Model, Atölye, Teknik, Maliyet, Sayısal, Ölçüler
  role: "dimension" | "measure" | "filter";
  grain?: "order" | "cost";
  hasValueList: boolean;
}

export interface PivotRequest {
  rows: string[];
  columns: string[];
  measures: DynamicReportAggregation[];
  filters: DynamicReportFilter[];
  targetCurrency?: string;
  rateMode?: string;
}

export interface PivotMeasureMeta {
  alias: string;
  label: string;
  dataType: string; // decimal | currency | int
}

export interface PivotRowGroup {
  level: number; // 0 = ilk satır alanı, 1 = ilk iki alan ...
  key: string[]; // grup ön ekinin alan değerleri
  label: string; // görünen etiket (ön ekin son değeri)
  startRow: number; // rowHeaders içindeki ilk detay satırı
  rowCount: number; // gruba ait detay satırı sayısı
  cells: (number | null)[][]; // [sütun][ölçü]
  totals: (number | null)[]; // [ölçü]
  groupCells: (number | null)[][]; // [sütun grubu][ölçü]
}

export interface PivotColumnGroup {
  level: number; // 0 = ilk sütun alanı, 1 = ilk iki alan ...
  key: string[]; // grup ön ekinin alan değerleri
  label: string; // görünen etiket (ön ekin son değeri)
  startCol: number; // columnKeys içindeki ilk yaprak sütun
  colCount: number; // gruba ait yaprak sütun sayısı
}

export interface PivotResponse {
  rowFields: string[];
  columnFields: string[];
  fieldLabels: Record<string, string>;
  measures: PivotMeasureMeta[];
  rowHeaders: string[][];
  columnKeys: string[];
  columnHeaders: string[][]; // her sütun anahtarının alan değerleri
  columnGroups: PivotColumnGroup[]; // 2+ sütun alanında her seviye için daraltılabilir gruplar
  cells: (number | null)[][][]; // [satır][sütun][ölçü]
  rowTotals: (number | null)[][];
  columnTotals: (number | null)[][];
  grandTotals: (number | null)[];
  groupCells: (number | null)[][][]; // [satır][sütun grubu][ölçü] — columnGroups sırasında
  groupTotals: (number | null)[][]; // [sütun grubu][ölçü] — columnGroups sırasında
  rowGroups: PivotRowGroup[]; // 2+ satır alanında daraltılabilir satır grupları
  recordCount: number;
  orderCount: number;
  targetCurrency: string;
  rateMode: string;
}

export interface ReportTemplate {
  reportTemplateId: string;
  name: string;
  description?: string;
  dataSource: string;
  configJson: string;
  isPublic: boolean;
  createdByUserId: string;
  createdByUserName?: string;
  createdAt: string;
  updatedAt?: string;
}

// ========================================
// External API Types (Softana Ticket API)
// ========================================

// JWT Token Authentication
export interface ExternalAuthTokenRequest {
  customerId: string;
  apiKey: string;
  externalUser: string;
  userName?: string;
  email?: string;
}

export interface ExternalAuthTokenResponse {
  token: string;
  expiresAt: string;
  userId: string;
  customerId: string;
  userName: string;
  email: string;
  role: string;
}

// Form Field Types
export type ExternalFormFieldType =
  | "text"
  | "textarea"
  | "number"
  | "date"
  | "select"
  | "checkbox"
  | "radio"
  | "file"
  | "photo"
  | "video";

export interface ExternalFormField {
  id: string;
  label: string;
  fieldType: ExternalFormFieldType;
  isRequired: boolean;
  sortOrder: number;
  placeholder?: string | null;
  options: string[];
  maxFileSizeMb?: number | null;
  allowedExtensions?: string | null;
  sectionId?: string | null;
  width?: "full" | "half" | null;
  column?: "left" | "right" | null;
}

export interface ExternalFormSection {
  id: string;
  title: string;
  description?: string | null;
  sortOrder: number;
  fields: ExternalFormField[];
}

export interface ExternalForm {
  id: string;
  name: string;
  description: string;
  fields: ExternalFormField[];
  sections: ExternalFormSection[];
}

// Form Submission
export interface ExternalFormSubmitResponse {
  id: string;
  statusCode: string;
  statusName: string;
  submittedAt: string;
}

// Submission List
export interface ExternalSubmissionListItem {
  id: string;
  formId: string;
  formName: string;
  statusCode: string;
  statusName: string;
  submittedAt: string;
  updatedAt: string;
}

// Submission Detail
export interface ExternalSubmissionValue {
  fieldId: string;
  label: string;
  fieldType: string;
  value: string;
}

export interface ExternalSubmissionFile {
  fieldId: string;
  label: string;
  originalFileName: string;
  url: string;
  sizeBytes: number;
  isImage: boolean;
}

export interface ExternalSubmissionDetail {
  id: string;
  formId: string;
  formName: string;
  statusCode: string;
  statusName: string;
  submittedAt: string;
  updatedAt: string;
  values: ExternalSubmissionValue[];
  files: ExternalSubmissionFile[];
}

// E-belge gönderim satırı — kullanıcı belgeyi madde madde tasarlar
export interface SendDocumentLine {
  name: string;
  description?: string;
  quantity: number;
  orderUnitId?: number;
  unitPrice: number;
  vatRate: number; // ayarlardaki listeden seçilir
}

// E-belge gönderim sonucu (POST /api/Order/{id}/send-document yanıtı)
export interface SendDocumentResult {
  serviceKind: string; // "EDM" | "FATURASIZ"
  documentNumber?: string;
  uuid?: string; // ETTN (yalnızca EDM)
  remoteState?: string;
  viewUrl?: string;
  grandTotal?: number;
  currencyCode?: string;
  isSimulated: boolean;
  warning?: string | null;
}

// Sipariş dışı (serbest) belge isteği (POST /api/EDocuments/standalone)
export interface StandaloneDocumentRequest {
  /** Pencere açılırken üretilen taslak kimliği — yeniden denemede aynı kalır, çift fatura kesilmez. */
  requestId: string;
  firmId: string;
  currencyCode: string;
  lines: SendDocumentLine[];
  note?: string;
}

// Kesilen belge — liste satırı (GET /api/EDocuments)
export interface EDocumentListItem {
  orderInvoiceId: string;
  /** Sipariş dışı belgede null. */
  orderId?: string | null;
  /** Siparişe bağlı olmadan kesildi. */
  isStandalone?: boolean;
  /** Sipariş dışı belgede ilk kalem (+ kalan kalem sayısı). */
  summary?: string | null;
  serviceKind: string; // "EDM" | "FATURASIZ"
  success: boolean;
  documentNumber?: string;
  remoteState?: string;
  gibStatusCode?: number;
  errorCode?: string;
  errorMessage?: string;
  viewUrl?: string;
  vatRate?: number;
  grandTotal?: number;
  currencyCode?: string;
  isSimulated: boolean;
  sentAt: string;
  sentBy?: string;
  firmId?: string;
  firmName?: string;
  firmCode?: string;
  modelCode?: string;
  hasDocumentId: boolean;
}

// Kesilen belge — detay (GET /api/EDocuments/{id})
export interface EDocumentDetail extends EDocumentListItem {
  lines?: SendDocumentLine[];
  firm?: {
    firmId: string;
    firmName: string;
    firmCode: string;
    taxNumber?: string;
    email?: string;
  };
  model?: { modelCode: string; modelName?: string };
  remote: {
    reachable: boolean;
    remoteState?: string;
    gibStatusCode?: number;
    gibStatusDescription?: string;
    eArchiveReportStatus?: string;
    error?: string;
  };
  attempts: {
    orderInvoiceId: string;
    success: boolean;
    errorCode?: string;
    errorMessage?: string;
    sentAt: string;
    sentBy?: string;
  }[];
}

// Satıcı kimliği (GET /api/CompanyProfile) — fatura başlığındaki "SATICI" bloğu
export interface CompanyProfile {
  companyProfileId: string;
  taxNumber: string;
  title: string;
  taxOfficeName?: string;
  streetName?: string;
  buildingNumber?: string;
  district?: string;
  city?: string;
  postalCode?: string;
  countryCode: string;
  countryName: string;
  phone?: string;
  email?: string;
  webSite?: string;
  mersisNo?: string;
  ticaretSicilNo?: string;
}

// ── Cari Hesap ve Tahsilat (receivables modülü) ──
export enum LedgerEntryKind {
  Invoice = 1,
  Payment = 2,
  DebitNote = 3,
  CreditNote = 4,
  Opening = 5,
  Reversal = 6,
}

export enum PaymentMethod {
  Cash = 1,
  BankTransfer = 2,
  Cheque = 3,
  CreditCard = 4,
  Other = 9,
}

export interface CurrencyBalance {
  currency: string;
  debit: number;
  credit: number;
  balance: number;
  overdue: number;
  notDue: number;
  aging0_30: number;
  aging31_60: number;
  aging61_90: number;
  aging90Plus: number;
}

export interface FirmReceivableSummary {
  firmId: string;
  firmName: string;
  firmCode: string;
  balances: CurrencyBalance[];
  lastInvoiceDate?: string | null;
  lastPaymentDate?: string | null;
  oldestOverdueDue?: string | null;
  openInvoiceCount: number;
}

export interface ReceivablesOverview {
  firms: FirmReceivableSummary[];
  totals: CurrencyBalance[];
  collectedLast30Days: Record<string, number>;
  defaultTermDays: number;
}

export interface LedgerEntry {
  firmLedgerEntryId: string;
  firmId: string;
  entryDate: string;
  kind: LedgerEntryKind;
  isDebit: boolean;
  amount: number;
  currency: string;
  paymentMethod?: PaymentMethod | null;
  dueDate?: string | null;
  description?: string | null;
  referenceNo?: string | null;
  orderInvoiceId?: string | null;
  orderId?: string | null;
  isSystem: boolean;
  createdBy?: string | null;
  createdAt: string;
  financialAccountId?: string | null;
  financialAccountName?: string | null;
  runningBalance: number;
}

export interface OpenItem {
  firmLedgerEntryId: string;
  entryDate: string;
  dueDate: string;
  referenceNo?: string | null;
  description?: string | null;
  amount: number;
  remaining: number;
  currency: string;
  daysOverdue: number;
}

export interface FirmStatement {
  firmId: string;
  firmName: string;
  firmCode: string;
  taxNumber?: string | null;
  balances: CurrencyBalance[];
  entries: LedgerEntry[];
  openItems: OpenItem[];
  defaultTermDays: number;
}

export interface LedgerEntryUpsert {
  firmId: string;
  kind: LedgerEntryKind;
  amount: number;
  currency: string;
  entryDate: string;
  dueDate?: string | null;
  paymentMethod?: PaymentMethod | null;
  description?: string | null;
  referenceNo?: string | null;
  /** Finans modülü: tahsilatın işlendiği kasa/banka hesabı */
  financialAccountId?: string | null;
  /** Hesap para birimi tahsilat biriminden farklıysa hesaba giren tutar */
  cashAmount?: number | null;
}

// ── Finans — Kasa ve Banka (finance modülü) ──
export enum FinancialAccountType { Cash = 1, Bank = 2, Pos = 3, CreditCard = 4 }
export enum CashTransactionSource { FirmCollection = 1, SupplierPayment = 2, Expense = 3, Personnel = 4, Transfer = 5, CustomerRefund = 6, OtherIncome = 7, Other = 9, ChequeCollection = 10, ChequePayment = 11 }

export interface FinancialAccount {
  financialAccountId: string;
  name: string;
  type: FinancialAccountType;
  currency: string;
  bankName?: string | null;
  branchName?: string | null;
  iban?: string | null;
  accountNo?: string | null;
  openingBalance: number;
  openingDate: string;
  isDefault: boolean;
  isActive: boolean;
  sortOrder: number;
  note?: string | null;
  balance: number;
  inToday: number;
  outToday: number;
  inMonth: number;
  outMonth: number;
  transactionCount: number;
  lastTransactionDate?: string | null;
}
export interface FinancialAccountUpsert {
  name: string;
  type: FinancialAccountType;
  currency: string;
  bankName?: string | null;
  branchName?: string | null;
  iban?: string | null;
  accountNo?: string | null;
  openingBalance: number;
  openingDate?: string | null;
  isDefault: boolean;
  isActive: boolean;
  sortOrder: number;
  note?: string | null;
}
export interface CashTransaction {
  cashTransactionId: string;
  financialAccountId: string;
  accountName: string;
  accountType: FinancialAccountType;
  transactionDate: string;
  isIn: boolean;
  amount: number;
  currency: string;
  source: CashTransactionSource;
  paymentMethod?: PaymentMethod | null;
  category?: string | null;
  counterparty?: string | null;
  description?: string | null;
  referenceNo?: string | null;
  firmId?: string | null;
  firmName?: string | null;
  firmLedgerEntryId?: string | null;
  supplierId?: string | null;
  supplierName?: string | null;
  supplierLedgerEntryId?: string | null;
  employeeId?: string | null;
  employeeName?: string | null;
  transferGroupId?: string | null;
  exchangeRate?: number | null;
  createdBy?: string | null;
  createdAt: string;
  runningBalance?: number | null;
}
export interface CashTransactionUpsert {
  financialAccountId: string;
  transactionDate: string;
  isIn: boolean;
  amount: number;
  source: CashTransactionSource;
  paymentMethod?: PaymentMethod | null;
  category?: string | null;
  counterparty?: string | null;
  description?: string | null;
  referenceNo?: string | null;
  firmId?: string | null;
  supplierId?: string | null;
  employeeId?: string | null;
  ledgerAmount?: number | null;
  ledgerCurrency?: string | null;
}
export interface CashTransfer { fromAccountId: string; toAccountId: string; transactionDate: string; amount: number; toAmount?: number | null; description?: string | null; referenceNo?: string | null }
export interface CashCurrencyTotal { currency: string; balance: number; in: number; out: number; inMonth: number; outMonth: number; inToday: number; outToday: number; accountCount: number }
export interface CashSourceTotal { source: CashTransactionSource; currency: string; in: number; out: number }
export interface CashOverview { accounts: FinancialAccount[]; totals: CashCurrencyTotal[]; unlinkedCollections: number; monthBySource: CashSourceTotal[]; receivablesEnabled: boolean; hrEnabled: boolean }
export interface CashList { items: CashTransaction[]; totals: CashCurrencyTotal[]; openingForRange?: number | null }
export interface CashQuery { from?: string; to?: string; accountId?: string; isIn?: boolean; source?: CashTransactionSource; q?: string }
export interface UnlinkedCollection { side: "firm" | "supplier"; ledgerEntryId: string; counterpartyId: string; counterpartyName: string; entryDate: string; amount: number; currency: string; paymentMethod?: PaymentMethod | null; referenceNo?: string | null; description?: string | null }
export interface OptionItem { id: string; name: string; sub?: string | null }

// ── Finans — Tedarikçi Carisi (finance modülü, Faz 1) ──
export interface SupplierLedgerEntry {
  supplierLedgerEntryId: string;
  supplierId: string;
  entryDate: string;
  kind: LedgerEntryKind;
  isDebit: boolean;
  amount: number;
  currency: string;
  paymentMethod?: PaymentMethod | null;
  dueDate?: string | null;
  description?: string | null;
  referenceNo?: string | null;
  purchaseOrderId?: string | null;
  purchaseOrderNumber?: string | null;
  purchaseReceiptId?: string | null;
  isSystem: boolean;
  createdBy?: string | null;
  createdAt: string;
  financialAccountId?: string | null;
  financialAccountName?: string | null;
  runningBalance: number;
}
export interface SupplierOpenItem { supplierLedgerEntryId: string; entryDate: string; dueDate: string; referenceNo?: string | null; description?: string | null; amount: number; remaining: number; currency: string; daysOverdue: number }
export interface SupplierPayableSummary { supplierId: string; supplierName: string; supplierCode?: string | null; isActive: boolean; paymentTermDays: number; balances: CurrencyBalance[]; lastInvoiceDate?: string | null; lastPaymentDate?: string | null; nextDueDate?: string | null; oldestOverdueDue?: string | null; openInvoiceCount: number }
export interface PayablesOverview { suppliers: SupplierPayableSummary[]; totals: CurrencyBalance[]; dueIn7Days: Record<string, number>; dueIn30Days: Record<string, number>; paidLast30Days: Record<string, number>; purchasingEnabled: boolean; unsyncedReceipts: number }
export interface SupplierStatement { supplierId: string; supplierName: string; supplierCode?: string | null; taxNumber?: string | null; paymentTermDays: number; currency: string; balances: CurrencyBalance[]; entries: SupplierLedgerEntry[]; openItems: SupplierOpenItem[] }
// ── Finans — Çek ve Senet (finance modülü, Faz 3) ──
export enum ChequeType { Cheque = 1, PromissoryNote = 2 }
export enum ChequeDirection { Received = 1, Issued = 2 }
export enum ChequeStatus { InPortfolio = 1, DepositedToBank = 2, Endorsed = 3, Collected = 4, Bounced = 5, Returned = 6 }
export interface ChequeHistoryItem { status: ChequeStatus; date: string; user?: string | null; note?: string | null }
export interface Cheque {
  chequeId: string; type: ChequeType; direction: ChequeDirection; status: ChequeStatus;
  number?: string | null; bankName?: string | null; branchName?: string | null; drawer?: string | null;
  issueDate: string; dueDate: string; amount: number; currency: string;
  firmId?: string | null; firmName?: string | null; supplierId?: string | null; supplierName?: string | null;
  financialAccountId?: string | null; accountName?: string | null;
  depositedAt?: string | null; endorsedAt?: string | null; closedAt?: string | null; note?: string | null;
  history: ChequeHistoryItem[]; daysToDue: number; createdBy?: string | null; createdAt: string;
}
export interface ChequeUpsert { type: ChequeType; direction: ChequeDirection; number?: string | null; bankName?: string | null; branchName?: string | null; drawer?: string | null; issueDate: string; dueDate: string; amount: number; currency: string; firmId?: string | null; supplierId?: string | null; financialAccountId?: string | null; note?: string | null }
export interface ChequeAction { date?: string | null; financialAccountId?: string | null; supplierId?: string | null; note?: string | null }
export interface ChequeQuery { direction?: ChequeDirection; status?: ChequeStatus; open?: boolean; dueFrom?: string; dueTo?: string; firmId?: string; supplierId?: string; q?: string }
export interface ChequeCurrencyTotal { currency: string; inPortfolio: number; atBank: number; endorsed: number; issuedOpen: number; dueIn7Received: number; dueIn30Received: number; dueIn7Issued: number; dueIn30Issued: number; overdueReceived: number; overdueIssued: number }
export interface ChequeOverview { totals: ChequeCurrencyTotal[]; openReceivedCount: number; openIssuedCount: number; bouncedCount: number; upcoming: Cheque[]; receivablesEnabled: boolean }

// ── Finans — Mizan ve Nakit Akış (finance modülü, Faz 4) ──
export interface TrialBalanceRow { code: string; name: string; group: "hazir" | "alici" | "satici" | "gelir" | "gider"; opening: number; periodDebit: number; periodCredit: number; closing: number; debitBalance: number; creditBalance: number; children: TrialBalanceRow[]; link?: string | null }
export interface TrialBalanceCurrency { currency: string; rateToTry?: number | null; rows: TrialBalanceRow[]; totalPeriodDebit: number; totalPeriodCredit: number; totalDebitBalance: number; totalCreditBalance: number; income: number; expense: number; netResult: number; netWorth: number }
export interface TrialBalance { from: string; to: string; currencies: TrialBalanceCurrency[]; rateDate?: string | null; note: string }
export interface CashFlowBucket { key: string; label: string; from: string; to: string; receivablesIn: number; chequesIn: number; payablesOut: number; chequesOut: number; in: number; out: number; net: number; projected: number; itemCount: number }
export interface CashFlowCurrency { currency: string; cashNow: number; buckets: CashFlowBucket[]; realized: CashFlowBucket[]; avgWeeklyIn: number; avgWeeklyOut: number; minProjected: number; minProjectedAt?: string | null }
export interface CashFlow { asOf: string; weeks: number; currencies: CashFlowCurrency[] }

export interface SupplierLedgerUpsert { supplierId: string; kind: LedgerEntryKind; amount: number; currency: string; entryDate: string; dueDate?: string | null; paymentMethod?: PaymentMethod | null; description?: string | null; referenceNo?: string | null; purchaseOrderId?: string | null; financialAccountId?: string | null; cashAmount?: number | null }

// ── Satın Alma (purchasing modülü) ──
export enum PurchaseOrderStatus {
  Draft = 1,
  Ordered = 2,
  PartiallyReceived = 3,
  Received = 4,
  Cancelled = 5,
}

export interface Supplier {
  supplierId: string;
  name: string;
  code?: string | null;
  taxNumber?: string | null;
  taxOffice?: string | null;
  contactPerson?: string | null;
  phone?: string | null;
  email?: string | null;
  address?: string | null;
  paymentTermDays: number;
  currency: string;
  note?: string | null;
  isActive: boolean;
  createdAt?: string;
}

export type SupplierUpsert = Omit<Supplier, "supplierId" | "createdAt">;

// Tedarikçiler sayfası (Stok modülü) — liste satırı ve detay
export interface SupplierRow extends Supplier { updatedAt?: string | null; stockCount: number; orderCount: number; lastOrderDate?: string | null }
export interface SupplierDetail {
  supplier: Supplier;
  stocks: { id: string; productCode: string; productName: string; unit: string; currentStock: number; minimumStock?: number | null; unitPrice?: number | null; currency?: string | null; stockType?: number }[];
  recentOrders: { purchaseOrderId: string; number: string; orderDate: string; status: number; currency: string; total: number }[] | null;
  purchasingEnabled: boolean;
}

export interface PurchaseLineUpsert {
  stockId: string;
  description?: string | null;
  quantity: number;
  unitPrice: number;
  vatRate: number;
}

export interface PurchaseOrderUpsert {
  supplierId: string;
  orderDate: string;
  expectedDate?: string | null;
  currency: string;
  note?: string | null;
  lines: PurchaseLineUpsert[];
}

export interface PurchaseOrderListItem {
  purchaseOrderId: string;
  number: string;
  supplierId: string;
  supplierName: string;
  orderDate: string;
  expectedDate?: string | null;
  status: PurchaseOrderStatus;
  currency: string;
  lineCount: number;
  netTotal: number;
  vatTotal: number;
  grossTotal: number;
  orderedQuantity: number;
  receivedQuantity: number;
  isOverdue: boolean;
  createdBy?: string | null;
}

export interface PurchaseLine {
  purchaseOrderLineId: string;
  stockId: string;
  stockCode: string;
  stockName: string;
  description?: string | null;
  quantity: number;
  unit: string;
  unitPrice: number;
  vatRate: number;
  receivedQuantity: number;
  remaining: number;
  net: number;
  vat: number;
  sortOrder: number;
}

export interface PurchaseReceiptItem {
  purchaseOrderLineId: string;
  stockName: string;
  quantity: number;
  unit: string;
  stockMovementCreated: boolean;
}

export interface PurchaseReceipt {
  purchaseReceiptId: string;
  receiptDate: string;
  waybillNo?: string | null;
  note?: string | null;
  receivedBy?: string | null;
  lines: PurchaseReceiptItem[];
}

export interface PurchaseOrderDetail extends PurchaseOrderListItem {
  note?: string | null;
  cancelReason?: string | null;
  orderedAt?: string | null;
  cancelledAt?: string | null;
  supplier?: SupplierUpsert | null;
  lines: PurchaseLine[];
  receipts: PurchaseReceipt[];
}

export interface PurchasingStats {
  draftCount: number;
  openCount: number;
  overdueCount: number;
  openAmountByCurrency: Record<string, number>;
  receivedLast30DaysByCurrency: Record<string, number>;
}

export interface ReceiveRequest {
  receiptDate: string;
  waybillNo?: string | null;
  note?: string | null;
  lines: { purchaseOrderLineId: string; quantity: number }[];
}

export interface StockPriceHistory {
  date: string;
  supplierName: string;
  orderNumber: string;
  unitPrice: number;
  currency: string;
  quantity: number;
}

// ============ Sevkiyat modülü (shipping) ============

export enum ShipmentStatus {
  Draft = 1,
  Shipped = 2,
  Delivered = 3,
  Cancelled = 4,
}

export interface ShipmentLineUpsert {
  orderId: string;
  quantity: number;
  packageCount?: number | null;
}

export interface ShipmentUpsert {
  firmId: string;
  shipmentDate: string;
  carrier?: string | null;
  vehiclePlate?: string | null;
  driverName?: string | null;
  driverTckn?: string | null;
  trackingNo?: string | null;
  packageCount?: number | null;
  grossWeightKg?: number | null;
  deliveryTitle?: string | null;
  deliveryAddress?: string | null;
  deliveryDistrict?: string | null;
  deliveryCity?: string | null;
  deliveryContact?: string | null;
  deliveryPhone?: string | null;
  waybillNo?: string | null;
  waybillDate?: string | null;
  note?: string | null;
  lines: ShipmentLineUpsert[];
}

export interface ShipmentListItem {
  shipmentId: string;
  number: string;
  firmId: string;
  firmName: string;
  firmCode?: string | null;
  status: ShipmentStatus;
  shipmentDate: string;
  shippedAt?: string | null;
  deliveredAt?: string | null;
  receivedBy?: string | null;
  carrier?: string | null;
  vehiclePlate?: string | null;
  packageCount?: number | null;
  waybillNo?: string | null;
  lineCount: number;
  totalQuantity: number;
  models?: string | null;
  createdBy?: string | null;
}

export interface ShipmentLine {
  shipmentLineId: string;
  orderId: string;
  modelCode?: string | null;
  modelName?: string | null;
  description?: string | null;
  quantity: number;
  unit: string;
  packageCount?: number | null;
  orderDate?: string | null;
  orderQuantity: number;
  orderShipped: number;
  hasStockMovement: boolean;
}

export interface ShipmentDetail {
  shipmentId: string;
  number: string;
  firmId: string;
  firmName: string;
  firmCode?: string | null;
  status: ShipmentStatus;
  shipmentDate: string;
  shippedAt?: string | null;
  deliveredAt?: string | null;
  receivedBy?: string | null;
  carrier?: string | null;
  vehiclePlate?: string | null;
  driverName?: string | null;
  driverTckn?: string | null;
  trackingNo?: string | null;
  packageCount?: number | null;
  grossWeightKg?: number | null;
  deliveryTitle?: string | null;
  deliveryAddress?: string | null;
  deliveryDistrict?: string | null;
  deliveryCity?: string | null;
  deliveryContact?: string | null;
  deliveryPhone?: string | null;
  waybillNo?: string | null;
  waybillDate?: string | null;
  note?: string | null;
  cancelledAt?: string | null;
  cancelReason?: string | null;
  createdAt: string;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  lines: ShipmentLine[];
  totalQuantity: number;
}

export interface ShippableOrder {
  orderId: string;
  modelCode?: string | null;
  modelName?: string | null;
  acceptanceDate: string;
  deadline?: string | null;
  orderStatusId: number;
  orderStatusName?: string | null;
  quantity: number;
  unit: string;
  shipped: number;
  remaining: number;
  invoiceNumber?: string | null;
}

export interface OrderShipmentSummary {
  orderId: string;
  quantity: number;
  shipped: number;
  remaining: number;
  shipments: ShipmentListItem[];
}

export interface ShippingStats {
  draftCount: number;
  inTransitCount: number;
  deliveredLast30: number;
  awaitingOrders: number;
  inTransitPackages: number;
}

export interface ShipRequest {
  shippedAt?: string | null;
  waybillNo?: string | null;
  waybillDate?: string | null;
}

export interface DeliverRequest {
  deliveredAt?: string | null;
  receivedBy?: string | null;
}

// ============ Bildirimler (çekirdek) ============

export enum NotificationType {
  OrderDeadlineSoon = 1,
  OrderOverdue = 2,
  StockLow = 3,
  TaskAssigned = 4,
  DocumentSent = 5,
  DocumentFailed = 6,
  ReceivableOverdue = 7,
  PurchaseOverdue = 8,
  ShipmentUndelivered = 9,
}

export interface AppNotification {
  notificationId: string;
  type: NotificationType;
  typeName: string;
  title: string;
  message?: string | null;
  link?: string | null;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationPreference {
  type: NotificationType;
  name: string;
  description: string;
  instant: boolean;
  inApp: boolean;
  email: boolean;
  applicable: boolean;
}

export interface NotificationScanResult {
  deadlineSoon: number;
  overdue: number;
  stockLow: number;
  receivableOverdue: number;
  purchaseOverdue: number;
  shipmentUndelivered: number;
  digestsSent: number;
  total: number;
}

// ============ Entegratör (EDM) hesabı — Ayarlar > Şirket Profili ============
// Parola hiçbir yanıtta taşınmaz; yalnız tanımlı olup olmadığı bilinir.

export interface EdmAccountStatus {
  isConfigured: boolean;
  edmUserName?: string | null;
  senderIdentifier?: string | null;
  senderAlias?: string | null;
  displayName?: string | null;
  defaultSerialCode?: string | null;
  hasSecretKey: boolean;
  isActive: boolean;
  simulation: boolean;
  updatedAt?: string | null;
  remainingCounter?: number | null;
}

export interface EdmAccountCredentials {
  edmUserName: string;
  edmPassword: string;
  /** Hesapta birden çok firma varsa seçilen VKN */
  senderIdentifier?: string | null;
  /** null: dokunma, "": temizle, dolu: ayarla */
  edmSecretKey?: string | null;
}

export interface EdmProbeCompany {
  taxNumber: string;
  title?: string | null;
  alias?: string | null;
}

export interface EdmProbeResult {
  success: boolean;
  failureReason?: string | null;
  companies: EdmProbeCompany[];
  remainingCounter?: number | null;
}

// ==================== RANDEVU VE TAKVİM (appointments modülü) ====================

export type AppointmentMode = 1 | 2; // 1 yüz yüze, 2 online
export type AppointmentModeOption = 1 | 2 | 3; // 1 yalnız yüz yüze, 2 yalnız online, 3 ikisi
/** 1 doğrulama bekliyor · 2 onay bekliyor · 3 onaylandı · 4 reddedildi · 5 iptal · 6 tamamlandı · 7 gelinmedi */
export type AppointmentStatus = 1 | 2 | 3 | 4 | 5 | 6 | 7;

export interface AppointmentType {
  appointmentTypeId?: string;
  name: string;
  description?: string | null;
  durationMinutes: number;
  modeOption: AppointmentModeOption;
  color?: string | null;
  isPublic: boolean;
  sortOrder: number;
  /** Bu türü karşılayan roller — tür kişiye değil ROLE bağlanır. */
  roleIds: number[];
}

export interface StaffBookingProfile {
  userId: string;
  slug: string;
  displayTitle?: string | null;
  intro?: string | null;
  isPublic: boolean;
  location?: string | null;
  defaultMeetingUrl?: string | null;
  minNoticeHours: number;
  maxAdvanceDays: number;
  slotStepMinutes: number;
  bufferMinutes: number;
  publicUrl?: string | null;
  /** Profil kaydedilmiş mi? false ise slug yalnız öneridir. */
  exists?: boolean;
  /** Çalışanın rolü — randevu türleri role bağlı olduğu için kurulum listesi bunu kullanır. */
  myRoleId?: number | null;
}

export interface StaffAvailabilityRow {
  dayOfWeek: number; // 0 Pazar … 6 Cumartesi
  startTime: string; // "09:00"
  endTime: string; // "18:00"
}

export interface AvailabilityExceptionRow {
  availabilityExceptionId?: string;
  date: string; // "2026-09-15"
  isClosed: boolean;
  startTime?: string | null;
  endTime?: string | null;
  reason?: string | null;
}

export interface CalendarBlock {
  calendarBlockId?: string;
  userId?: string;
  staffName?: string;
  title: string;
  startAt: string;
  endAt: string;
  isAllDay: boolean;
}

export interface Appointment {
  appointmentId: string;
  number: string;
  userId: string;
  staffName: string;
  appointmentTypeId: string;
  typeName: string;
  color?: string | null;
  startAt: string;
  endAt: string;
  localRange: string;
  mode: AppointmentMode;
  status: AppointmentStatus;
  statusName: string;
  location?: string | null;
  meetingUrl?: string | null;
  guestName: string;
  guestEmail: string;
  guestPhone?: string | null;
  guestCompany?: string | null;
  guestNote?: string | null;
  firmId?: string | null;
  firmName?: string | null;
  cancelReason?: string | null;
  createdAt: string;
}

export interface AppointmentCalendar {
  appointments: Appointment[];
  blocks: CalendarBlock[];
}
export interface AppointmentPerson { userId: string; name: string; role: string; relation: "me" | "team" | "all" }
export interface AppointmentPeople { canAll: boolean; teamCount: number; people: AppointmentPerson[] }

// ---- Girişsiz randevu sayfası ----

export interface PublicStaff {
  slug: string;
  name: string;
  title?: string | null;
  intro?: string | null;
}

export interface PublicAppointmentType {
  appointmentTypeId: string;
  name: string;
  description?: string | null;
  durationMinutes: number;
  modeOption: AppointmentModeOption;
  color?: string | null;
}

export interface BookingPage {
  staff: PublicStaff;
  types: PublicAppointmentType[];
  timeZoneLabel: string;
  minNoticeHours: number;
  maxAdvanceDays: number;
  location?: string | null;
  requiresApproval: boolean;
}

export interface BookingSlot {
  startAt: string;
  endAt: string;
  localTime: string;
}

export interface BookingSlotDay {
  date: string;
  slots: BookingSlot[];
}

export interface BookingRequest {
  appointmentTypeId: string;
  startAt: string;
  mode: AppointmentMode;
  guestName: string;
  guestEmail: string;
  guestPhone?: string;
  guestCompany?: string;
  guestNote?: string;
  consentAccepted: boolean;
}

export interface GuestAppointment {
  number: string;
  staffName: string;
  typeName: string;
  startAt: string;
  localWhen: string;
  mode: AppointmentMode;
  status: AppointmentStatus;
  statusName: string;
  location?: string | null;
  meetingUrl?: string | null;
  canCancel: boolean;
}

/** Çalışanın bağladığı Google hesabının durumu. Gizli hiçbir alan taşımaz. */
export interface GoogleAccountStatus {
  /** Sunucuda ClientId/Secret tanımlı mı? Değilse bağlan düğmesi gösterilmez. */
  configured: boolean;
  connected: boolean;
  googleEmail?: string | null;
  connectedAt?: string | null;
  lastSuccessAt?: string | null;
  lastError?: string | null;
}

// ============================================
// İNSAN KAYNAKLARI (hr) — Faz 1
// ============================================
export enum EmploymentType { FullTime = 1, PartTime = 2, Shift = 3, Intern = 4, Contractor = 5 }

export interface HrSummary {
  total: number; loginActive: number; loginPassive: number; pendingFirstLogin: number; newLast90Days: number;
  departments: number; positions: number; canSeeAll: boolean;
}

export interface HrNamedItem {
  departmentId?: string;
  name: string; description?: string | null; sortOrder: number; isActive: boolean; employeeCount: number;
}
/** Pozisyon = sistem rolü (Roller ekranıyla aynı tablo); yalnız okunur. */
export interface HrPositionItem { positionId: number; roleId: number; name: string; description?: string | null; sortOrder: number; isActive: boolean; isSystem: boolean; employeeCount: number; userCount: number }

export interface Employee {
  employeeId: string; employeeNumber: string; firstName: string; lastName: string; fullName: string;
  userId?: string | null; userEmail?: string | null; userRole?: string | null;
  /** Giriş hesabı açık mı (kart = kullanıcı). null: eski kart, hesap yok */
  loginActive?: boolean | null; isFirstLogin?: boolean | null;
  nationalId?: string | null; iban?: string | null; healthNotes?: string | null; sensitiveVisible: boolean;
  birthDate?: string | null; phone?: string | null; email?: string | null; address?: string | null;
  emergencyContactName?: string | null; emergencyContactPhone?: string | null;
  departmentId?: string | null; departmentName?: string | null;
  positionId?: number | null; roleId?: number | null; positionName?: string | null;
  workshopIds: string[]; workshopNames: string[];
  managerEmployeeId?: string | null; managerName?: string | null;
  hireDate: string; terminationDate?: string | null; terminationReason?: string | null;
  employmentType: EmploymentType;
  workDays: string; workStart: string; workEnd: string; breakMinutes: number;
  annualLeaveOverride?: number | null; notes?: string | null; isActive: boolean;
  createdAt: string; updatedAt?: string | null;
  shiftId?: string | null; shiftName?: string | null; hasQr?: boolean; hasPin?: boolean; deviceUserId?: string | null;
}

export interface EmployeeUpsert {
  employeeNumber?: string; firstName: string; lastName: string;
  nationalId?: string | null; birthDate?: string | null; phone?: string | null; email?: string | null; address?: string | null;
  emergencyContactName?: string | null; emergencyContactPhone?: string | null; iban?: string | null; healthNotes?: string | null;
  departmentId?: string | null; positionId?: number | null; workshopIds: string[]; managerEmployeeId?: string | null;
  hireDate: string; employmentType: EmploymentType;
  workDays: string; workStart: string; workEnd: string; breakMinutes: number;
  annualLeaveOverride?: number | null; notes?: string | null; shiftId?: string | null;
}

export interface EmployeeLoginResult { userId: string; email: string; temporaryPassword: string; role: string; appUrl?: string | null; emailSent?: boolean }

// ---- İK Faz 2: izin ve dosyalar ----
export enum LeaveStatus { Pending = 1, Approved = 2, Rejected = 3, Cancelled = 4 }
export enum DocumentCategory {
  Contract = 1, IdCopy = 2, HealthReport = 3, Certificate = 4, Disciplinary = 5, Leave = 6, Other = 9,
  Residence = 10, PopulationRecord = 11, Photo = 12, MilitaryStatus = 13, CriminalRecord = 14, DriverLicense = 15,
  SgkEntry = 16, JobDescription = 17, KvkkConsent = 18, FamilyStatus = 19, BankAccount = 20, OhsTraining = 21,
  PeriodicExam = 22, Payslip = 23, Advance = 24, Resignation = 25, Release = 26, SgkExit = 27, WorkCertificate = 28, Reference = 29,
}
export interface DocChecklistItem { category: number; label: string; group: string; sensitive: boolean; present: boolean; count: number; expired: boolean }
export interface DocChecklist { required: number; present: number; items: DocChecklistItem[] }
export interface DocComplianceRow { employeeId: string; employeeNumber: string; fullName: string; departmentName?: string | null; positionName?: string | null; hireDate: string; required: number; present: number; missing: number[]; missingLabels: string[]; expiredLabels: string[] }
export interface DocCompliance { required: number; employees: number; complete: number; missingTotal: number; expiredTotal: number; byCategory: { category: number; label: string; missing: number }[]; rows: DocComplianceRow[] }

export interface LeaveType {
  leaveTypeId: string; name: string; description?: string | null; isPaid: boolean; deductsFromAnnual: boolean;
  requiresApproval: boolean; requiresDocument: boolean; maxDaysPerRequest: number; color: string; sortOrder: number; isActive: boolean;
}
export interface LeaveTypeUpsert {
  name: string; description?: string; isPaid: boolean; deductsFromAnnual: boolean; requiresApproval: boolean; requiresDocument: boolean;
  maxDaysPerRequest: number; color: string; sortOrder?: number; isActive?: boolean;
}
export interface PublicHoliday { publicHolidayId: string; date: string; name: string; isHalfDay: boolean }
export interface LeaveBalance {
  periodStart: string; periodEnd: string; entitlement: number; used: number; pending: number; remaining: number; overridden: boolean; tenureYears: number;
}
export interface LeavePreview {
  workDays: number; balance: LeaveBalance | null; insufficientBalance: boolean; exceedsMax: boolean; requiresDocument: boolean; requiresApproval: boolean;
  overlaps: { leaveRequestId: string; startDate: string; endDate: string; status: LeaveStatus }[]; sameDepartmentOnLeave: string[];
}
export interface LeaveRequestRow {
  leaveRequestId: string; employeeId: string; employeeName: string; employeeNumber?: string | null; departmentName?: string | null; employeeUserId?: string | null;
  leaveTypeId: string; leaveTypeName?: string | null; leaveTypeColor?: string | null; deductsFromAnnual: boolean;
  startDate: string; endDate: string; startHalfDay: boolean; endHalfDay: boolean; workDays: number; reason?: string | null; status: LeaveStatus;
  requestedBy?: string | null; decidedBy?: string | null; decidedAt?: string | null; decisionNote?: string | null; documentId?: string | null; createdAt: string; canDecide: boolean;
}
export interface LeaveRequestCreate {
  employeeId: string; leaveTypeId: string; startDate: string; endDate: string; startHalfDay: boolean; endHalfDay: boolean; reason?: string; documentId?: string | null;
}
export interface HrDocumentType { documentTypeId: number; name: string; groupName: string; isSensitive: boolean; isRequired: boolean; sortOrder: number; isActive: boolean; isSystem: boolean; description?: string | null }
export interface HrDocumentTypeUpsert { name: string; groupName: string; isSensitive: boolean; isRequired: boolean; sortOrder?: number; isActive?: boolean; description?: string }
export interface EmployeeDocumentRow {
  employeeDocumentId: string; employeeId: string; category: number; typeName: string; groupName?: string | null; isSensitive: boolean; hidden: boolean;
  fileName: string; contentType?: string | null; size: number; description?: string | null; validUntil?: string | null;
  expired: boolean; expiringSoon: boolean; createdAt: string; createdBy?: string | null;
}

// ---- İK Faz 3: giriş-çıkış ----
export enum PunchKind { In = 1, Out = 2 }
export enum PunchSource { Web = 1, Kiosk = 2, Device = 3, Import = 4, Manual = 5 }
export enum DeviceKind { QrKiosk = 1, Fingerprint = 2, CardReader = 3 }
export enum DayStatus { OffDay = 0, Holiday = 1, OnLeave = 2, Present = 3, Incomplete = 4, Absent = 5, Future = 6 }

export interface AttendanceSettingsRow {
  webCheckInEnabled: boolean; kioskEnabled: boolean; deviceEnabled: boolean; kioskPinAllowed: boolean;
  lateToleranceMinutes: number; earlyLeaveToleranceMinutes: number; overtimeThresholdMinutes: number; incompleteAfterMinutes: number; duplicateWindowMinutes: number;
}
export interface AttendanceDeviceRow { attendanceDeviceId: string; name: string; kind: DeviceKind; location?: string | null; keyPrefix: string; lastSeenAt?: string | null; punchCount: number; isActive: boolean; createdAt: string }
export interface AttendanceConfig { settings: AttendanceSettingsRow; devices: AttendanceDeviceRow[] | null; kioskPath: string; devicePushPath: string; devicePunchesPath: string }
export interface ShiftRow { shiftId: string; name: string; startTime: string; endTime: string; breakMinutes: number; workDays: string; crossesMidnight: boolean; color: string; isActive: boolean; employeeCount: number }
export interface DaySummaryRow {
  employeeId: string; employeeName: string; employeeNumber: string; departmentName?: string | null; date: string; status: DayStatus; statusNote?: string | null;
  checkIn?: string | null; checkOut?: string | null; inSource?: PunchSource | null; outSource?: PunchSource | null;
  lateMinutes: number; earlyLeaveMinutes: number; overtimeMinutes: number; workedMinutes: number; expectedMinutes: number; scheduleText: string; punchCount: number;
}
export interface DailyBoard { date: string; now: string; present: number; incomplete: number; absent: number; onLeave: number; off: number; late: number; inside: number; rows: DaySummaryRow[] }
export interface MonthSummaryRow {
  employeeId: string; employeeName: string; employeeNumber: string; departmentName?: string | null; workDays: number; present: number; incomplete: number; absent: number;
  paidLeave: number; unpaidLeave: number; holidays: number; lateCount: number; lateMinutes: number; earlyLeaveMinutes: number; overtimeMinutes: number; workedMinutes: number; expectedMinutes: number; days: DayStatus[];
}
export interface MyAttendance { hasCard: boolean; employeeId?: string; webEnabled?: boolean; canPunch?: boolean; nextKind?: PunchKind; today?: DaySummaryRow; now?: string }
export interface PunchRow { attendancePunchId: string; punchedAt: string; kind: PunchKind; source: PunchSource; device?: string | null; note?: string | null; enteredBy?: string | null }
export interface KioskIdentity { employeeNumber: string; hasQr: boolean; qrToken?: string | null; hasPin: boolean; deviceUserId?: string | null }

// ---- İK Faz 4: self-servis, ekip, raporlar ----
export interface HrDocBrief { employeeDocumentId: string; category: number; typeName?: string; fileName: string; validUntil?: string | null }
export interface HrMeLeave { leaveRequestId: string; startDate: string; endDate: string; workDays: number; status: LeaveStatus; leaveTypeName: string; leaveTypeColor: string; decisionNote?: string | null }
export interface HrMe {
  hasCard: boolean; isManager: boolean; teamCount: number;
  employee?: Employee; balance?: LeaveBalance; leaves?: HrMeLeave[];
  leaveByType?: { name: string; color: string; days: number; count: number }[];
  today?: DaySummaryRow; month?: MonthSummaryRow | null;
  attendance?: { webEnabled: boolean; canPunch: boolean; canView: boolean; nextKind: PunchKind };
  documents?: { total: number; expiring: HrDocBrief[]; expired: HrDocBrief[] };
  departmentOnLeaveToday?: string[]; now?: string;
}
export interface HrTeamLeave { leaveRequestId: string; employeeId: string; employeeName: string; leaveTypeName: string; leaveTypeColor: string; startDate: string; endDate: string; workDays: number; reason?: string | null; createdAt?: string }
export interface HrTeamRow {
  employeeId: string; employeeNumber: string; firstName: string; lastName: string; fullName: string; departmentName?: string | null; positionName?: string | null;
  phone?: string | null; email?: string | null; hireDate: string; userId?: string | null;
  today?: DaySummaryRow | null;
  month?: { workDays: number; present: number; incomplete: number; absent: number; lateCount: number; lateMinutes: number; overtimeMinutes: number; workedMinutes: number; expectedMinutes: number } | null;
  balance: { entitlement: number; used: number; pending: number; remaining: number }; pendingLeaves: number;
}
export interface HrTeam {
  isManager: boolean; canApprove?: boolean; canSeeAttendance?: boolean; date?: string; rows: HrTeamRow[];
  pendingLeaves?: HrTeamLeave[]; upcomingLeaves?: HrTeamLeave[];
  summary?: { total: number; present: number; onLeave: number; absent: number; late: number; pending: number };
}
export interface LeaveBalanceReportRow {
  employeeId: string; employeeNumber: string; fullName: string; departmentName?: string | null; positionName?: string | null; hireDate: string; tenureYears: number;
  periodStart: string; periodEnd: string; entitlement: number; used: number; pending: number; remaining: number; overridden: boolean; byType: Record<string, number>; yearTotal: number;
}
export interface LeaveBalanceReport {
  asOf: string; types: string[]; rows: LeaveBalanceReportRow[];
  summary: { employees: number; entitlement: number; used: number; pending: number; remaining: number; noEntitlement: number; exhausted: number; yearTotal: number };
}

// ============ Gelen faturalar (platform gelen kutusu) ============

/** Gelen e-Fatura — platform kaydı + yerel tedarikçi/firma eşleşmesi ve cari durumu. */
export interface IncomingInvoice {
  uuid: string;
  invoiceNumber: string;
  /** TemelFatura | TicariFatura | EArsivFatura | Ihracat | YolcuBeraberFatura */
  scenario: string;
  state: string;
  rawStatus?: string | null;
  senderIdentifier?: string | null;
  senderName?: string | null;
  payableAmount: number;
  currencyCode: string;
  /** yyyy-MM-dd */
  issueDate: string;
  receivedAt?: string | null;
  markedRead: boolean;
  /** Satis | Iade | Tevkifat …; eski platform sürümünde boş */
  invoiceType?: string | null;
  isReturn: boolean;
  responseDueDate?: string | null;
  daysLeft?: number | null;
  applicationResponse?: string | null;
  canRespond: boolean;
  supplierId?: string | null;
  supplierName?: string | null;
  firmId?: string | null;
  firmName?: string | null;
  postedTo?: "supplier" | "firm" | null;
  postedEntryId?: string | null;
  postedPartyName?: string | null;
}

export interface InboxHealth {
  synced: boolean;
  fetchedThrough?: string | null;
  incompleteSince?: string | null;
  complete?: boolean;
  detail?: string;
}

export interface InboxSyncResult {
  added: number;
  fetched: number;
  incompleteSince?: string | null;
}

export interface LedgerParty {
  id: string;
  name: string;
  taxNumber?: string | null;
  isActive: boolean;
}

/** Faturası beklenen mal kabul kaydı — gelen faturayla eşleştirme adayı. */
export interface ReceiptMatchCandidate {
  entryId: string;
  entryDate: string;
  amount: number;
  currency: string;
  referenceNo?: string | null;
  description?: string | null;
  purchaseOrderNumber?: string | null;
}

export interface PostIncomingInvoiceRequest {
  supplierId?: string | null;
  createSupplier?: boolean;
  matchEntryId?: string | null;
  firmId?: string | null;
  dueDate?: string | null;
}

export interface PostIncomingInvoiceResult {
  postedTo: "supplier" | "firm";
  entryId: string;
  partyId: string;
  partyName: string;
}
